/* ==========================================================================
   SearcherFlightHotel > Config
   ========================================================================== */

/* Modules */

/* Configuration */
const configuration = {
    selector: '[data-component="SearcherFlightHotel"]',
    enpoints: {
        airportByDestination: '/packagesalexswc/AjaxServices/GetAirportCodeByDestination'
    },
    type: {
        autocomplete: 'autocomplete',
        calendar: 'calendar',
        loading: 'modal-loading-flight-hotel',
        uipanel: {
            trigger: 'ui-panel-passenger-flight-trigger'
        },
        submit: 'submit'
    },
    css: {
        searcher: '',
        calendar: 'searcher__item--calendar searcher__item--large',
        item: 'searcher__item',
        itemLarge: 'searcher__item--large',
        itemSmall: 'searcher__item--small',
        itemButton: 'searcher__item--submit',
        itemWithMargin: 'searcher__item--with-margin',
        itemDiscount: 'searcher__item--discounts',
        itemClass: 'searcher__item--class',
        button: 'searcher__button',
        buttonIcon: 'searcher__button-icon',
        multidestination: 'searcher--multidestination',
        row: 'searcher__row',
        disabled: 'is-disabled',
        hidden: 'is-hidden',
        hasDiscounts: 'has-discounts'
    },
    class: {
        selector: '[data-component="Select"][data-type="input-class"]',
        choices: {
            searchEnabled: false
        },
        config: {
            styles: ['searcher__item', 'searcher__item--class', 'is-hidden'],
            data: {
                type: 'input-class'
            }
        }
    },
    discounts: {
        selector: '[data-component="Select"][data-type="discounts"]',
        config: {
            styles: ['searcher__item', 'searcher__item--discounts', 'is-hidden'],
            data: {
                type: 'discounts'
            }
        }
    },
    origin: {
        config: {
            styles: ['searcher__item', 'searcher__item--origin'],
            data: {
                type: 'autocomplete-0'
            },
            provider: {
                name: 'borg',
                types: ['airport'],
                limit: 12,
                parameters: {
                    o: '',
                    p: '',
                    n: 20
                }
            }
        }
    },
    destination: {
        config: {
            styles: ['searcher__item', 'searcher__item--destination'],
            data: {
                type: 'autocomplete-1'
            },
            provider: {
                name: 'borg',
                types: ['airport'],
                limit: 12,
                parameters: {
                    o: '',
                    p: '',
                    n: 20
                }
            }
        }
    },
    accommodationPanel: {
        css: 'ui-panel--accommodation-packages',
        type: 'ui-panel-accommodation-packages',
        selector: '[data-component="UiPanel"][data-type="ui-panel-accommodation-packages"]',
        hasClose: true,
        maxRooms: 4,
        adults: {
            min: 1,
            max: 6,
            value: 2
        },
        children: {
            min: 0,
            max: 5,
            value: 0,
            ages: {
                min: 0,
                max: 17
            }
        }
    },
    calendar: {
        type: {
            calendarDay: 'calendar-day',
            calendarDayText: 'calendar-day-text',
            calendarDayPrice: 'calendar-day-price'
        },
        css: {
            visible: 'is-visible',
            calendarDirectFlight: 'flatpickr-day--direct-flight',
            calendarDay: 'flatpickr-day__day',
            disabledDay: 'disabled'
        }
    },
    disableDays: [
        '2020/05/25',
        '2020/05/26',
        '2020/05/27',
        '2020/05/28',
        '2020/05/29',
        '2020/05/30',
        '2020/05/31',
        '2020/06/01',
        '2020/06/02',
        '2020/06/03',
        '2020/06/04',
        '2020/06/05',
        '2020/06/06',
        '2020/06/07',
        '2020/06/08',
        '2020/06/09',
        '2020/06/10',
        '2020/06/11',
        '2020/06/12',
        '2020/06/13',
        '2020/06/14',
        '2020/06/15'
    ],
    accommodationTrigger: {
        type: 'input-accommodation-trigger',
        selector: '[data-component="Input"][data-type="input-accommodation-trigger"]',
        icon: 'user'
    },
    image: {
        cdn: '//cdn.logitravel.com',
        src: '/contenidos/fotos/CIUDADES/##code##.jpg',
        alternative: '/comun/images/lineas/paquetes_800x600.jpg',
        resize: '/wsimgresize/resize/crop/334/260/',
        quality: '80'
    },
    getStyle: element => configuration[element].css,
    getType: element => configuration[element].type,
    getSelector: element => `${configuration.selector} ${configuration[element].selector}`,

    submitUrl: '/packagesasyncstepssp/AvailabilityMaterial/'
};

const config = () => configuration;

module.exports = config;
